import { render } from "./CustomTextFilter.vue?vue&type=template&id=395dc6c1&scoped=true"
import script from "./CustomTextFilter.vue?vue&type=script&lang=js"
export * from "./CustomTextFilter.vue?vue&type=script&lang=js"

import "./CustomTextFilter.vue?vue&type=style&index=0&id=395dc6c1&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395dc6c1"]])

export default __exports__